module.exports = __webpack_public_path__ + "img/vis_10.7dd75489.jpg";